<section id="home" class="section welcome-area bg-overlay bg-overlay-color1-step1 overflow-hidden d-flex align-items-center">
    <div class="container">
        <div fxShow.lt-md fxHide.gt-md style="padding-top: 100px;">

        </div>
        <div class="row align-items-center">
            <div class="col-12 col-md-7">
                <div class="welcome-intro">
                    <h1 class="text-white">Denver's premier digital agency</h1>
                    <p class="text-white my-4">When you go with Avanta Marketing, you can rest assured that you are going with one of Denver's best. We pride ourselves in our commitment to our customers and ensure they receive only the highest quality of work.</p>
                    <div class="button-group">
                        <a [routerLink]="'process'" class="btn btn-bordered-white" (click)="analyticLog('view-process')">Check out the Process</a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-5">
                <div class="welcome-thumb-wrapper mt-5 mt-md-0">
                    <span class="welcome-thumb-1">
                        <img class="welcome-animation d-block ml-auto" src="assets/img/welcome_thumb_1.png" alt="">
                    </span>
                    <span class="welcome-thumb-2">
                        <img class="welcome-animation d-block" src="assets/img/welcome_thumb_2.png" alt="">
                    </span>
                    <!-- <span class="welcome-thumb-3">
                        <img class="welcome-animation d-block" src="assets/img/welcome_thumb_3.png" alt="">
                    </span> -->
                    <span class="welcome-thumb-4" fxHide.lt-sm fxShow.gt-sm>
                        <img class="welcome-animation d-block" src="assets/img/welcome_thumb_4.png" alt="">
                    </span>
                    <span class="welcome-thumb-5">
                        <img class="welcome-animation d-block" src="assets/img/welcome_thumb_5.png" alt="">
                    </span>
                    <!-- <span class="welcome-thumb-6">
                        <img class="welcome-animation d-block" src="assets/img/welcome_thumb_6.png" alt="">
                    </span> -->
                </div>
            </div>
        </div>
    </div>
    <div class="shape shape-bottom">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none" fill="#FFFFFF">
            <path class="shape-fill" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7
c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4
c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path>
        </svg>
    </div>
</section>

<!-- OPENING STATEMENT  -->
<section class="section content-area ptb_100">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-12 col-lg-6">
                <div class="content-inner text-center">
                    <div class="section-heading text-center mb-3">
                        <h1 style='font-size: 3.5em'>We're here to help grow your business.</h1>
                        <p class="d-none d-sm-block mt-4">We want you to be able to see the effect that proper SEO and Ad campaigns can have on your business. Provided with each package is a PDF outlining our metrics for success</p>
                        <p class="d-block d-sm-none mt-4">We want you to be able to see the effect that proper SEO and Ad campaigns can have on your business.</p>
                    </div>
                    <ul class="content-list text-left">
                        <li class="single-content-list media py-2" *ngFor="let contentEntry of contentList">
                            <div class="content-icon pr-4">
                                <span class="color-1"><i class="fas fa-angle-double-right"></i></span>
                            </div>
                            <div class="content-text media-body">
                                <span><b>{{contentEntry.title}}</b><br>{{contentEntry.description}}</span>
                            </div>
                        </li>
                    </ul>
                    <a [routerLink]="'about'" class="btn btn-bordered mt-4">Learn More</a>
                </div>
            </div>
           
            
            <div class="col-12 col-lg-6">
                <!-- Service Thumb -->
                <div class="service-thumb mx-auto pt-4 pt-lg-0 mt-5">
                    <img src="assets/img/content_thumb.png" alt="">
                </div>
            </div>
        </div>
    </div>
</section>

<!-- SERVICES SECTION -->
<section id="service" class="section service-area bg-grey ptb_150">
    <div class="shape shape-top">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none" fill="#FFFFFF">
            <path class="shape-fill" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7
        c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4
        c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path>
        </svg>
    </div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-8">
                <div class="section-heading text-center">
                    <h2>Here are our most requested digital services</h2>
                    <p class="d-none d-sm-block mt-4">While we do offer quite a few options, these are the options our clients have most frequently used.</p>
                    <p class="d-block d-sm-none mt-4">These are the options our clients have most frequently used.</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4" *ngFor="let service of serviceList">
                <div class="single-service service-gallery overflow-hidden">
                    <div class="service-thumb">
                        <a href="#"><img src="{{service.image}}" alt=""></a>
                    </div>
                    <div class="service-content bg-white">
                        <a href="#">
                            <h3>{{service.title}}</h3>
                        </a>
                        <p class="py-3">{{service.message}}</p>
                        <a class="service-btn" [routerLink]="'services/post/'+service.link">Learn More</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <a  class="btn btn-bordered mt-4" [routerLink]="'services'">See More Services</a>
    </div>
    <div class="shape shape-bottom">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none" fill="#016499 ">
            <path class="shape-fill" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7
c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4
c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path>
        </svg>
    </div>
</section>

<!-- REVIEWS SECTION -->
<section id="review" class="section review-area bg-overlay bg-overlay-color1 ptb_100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-7">
                <div class="section-heading text-center">
                    <h2 class="text-white">Our clients says</h2>
                    <p class="text-white mt-4">Check out our reviews from our clients!</p>
                </div>
            </div>
        </div>
        <div>
            <owl-carousel-o [options]="customOptions" class="client-reviews">
            <ng-container *ngFor="let review of reviews">
                <ng-template carouselSlide [id]="review.id">
                    <div class="single-review p-5">
                        <div class="review-content">
                            <div class="review-text">
                                <p>{{review.review}}</p>
                            </div>
                            <div class="quot-icon">
                                <img class="avatar-sm" src="assets/img/quote.png" alt="">
                            </div>
                        </div>
                        <div class="reviewer media mt-3" style="margin-left: -5px;">
                            <div class="reviewer-thumb">
                                <img class="avatar-lg radius-100" src="{{review.avatarSrc}}" alt="">
                            </div>
                            <div class="reviewer-meta media-body align-self-center ml-2">
                                <h5 class="reviewer-name color-primary mb-2">{{review.reviewer}}</h5>
                                <h6 class="text-secondary fw-3">{{review.title}}</h6>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
        </owl-carousel-o>
            
        </div>
    </div>
</section>